import React, { Children } from "react";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Colors from 'constants/Colors';

import { Content, Heading, RightButton } from "./styles";

const propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.bool,
  rightTitle: PropTypes.string,
  action: PropTypes.func,
};

export default function ContentCard({
  title,
  children,
  noPadding,
  noBorder,
  customShadow,
  colorBorder,
  mr,
  mt,
  rightTitle,
  action,
  color = Colors.SECONDARY,
}) {

  return (
    <>
      <Heading mr={mr} mt={mt} color={color}>
        {title ? title : "Content Title"}
        {!rightTitle ? (
          ""
        ) : (
          <RightButton
            onClick={action}
          >
          {rightTitle}
          </RightButton>
        )}
      </Heading>
      <Content colorBorder={colorBorder} mr={mr} noBorder={noBorder} customShadow={customShadow} noPadding={noPadding}>{children}</Content>
    </>
  );
}
ContentCard.propTypes = propTypes;
